@if (!baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Utah</h2>
  @if (baseRules?.No_Selection === "Yes") {
    <div class="axis-form-group">
      <label class="axis-control-label">{{ controls[0].label }}</label>
    </div>
  }
}
